export function capitalizeFirstLetter(phrase: string): string {

    if (!phrase) return '';

    const exceptions = ['de', 'da', 'do', 'das', 'dos', 'e', 'em', 'a', 'o', 'as', 'os', 'para', 'com', 'sem', 'sob', 'sobre'];

    return phrase
        .trim()
        .split(/\s+/)
        .map((word, index) => {
            const lowerWord = word.toLowerCase();
            
            if (exceptions.includes(lowerWord) && index !== 0) {
                return lowerWord;
            }
            
            // Força primeira letra maiúscula e resto minúsculo
            return lowerWord.charAt(0).toUpperCase() + lowerWord.slice(1);
        })
        .join(' ');

}